<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import pdf from 'vue-pdf';
import Swal from 'sweetalert2'

import * as axios from "axios";
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, pdf, Swal },
  data() {
    return {
      tosOk: false,
      userId: 0
    }
  },
  watch: {
  },
  async mounted() {
    this.userId = JSON.parse(localStorage["auth.currentUser"]).id;
    await this.fetchToSFile();

  },
  methods: {
    setTosOk(){
      this.tosOk = true;
    },
    async fetchToSFile() {
            const file = await axios(process.env.VUE_APP_API_URL + `users/${this.userId}/ToS`, {
                responseType: "blob"
            });
            if(await file.data.text() === 'true'){
                this.setTosOk();
                return;
            }
            var blob = new Blob([file.data], {type: 'application/pdf'});
            var url = URL.createObjectURL(blob);
            this.showFile(this.userId, url);
    },
    async showFile(userId, url) {
            Swal.fire({
                title: 'Terms of Service',
                html: `<iframe id="tos" src="${url}" frameborder="0"> </iframe>`,
                confirmButtonText: 'I accept the Terms of Service',
                customClass: `swal2-height`,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value) {
                    const response = await axios.put( process.env.VUE_APP_API_URL + `users/${userId}/ToS`, {userId});
                    Swal.fire('Saved!', '', 'success');
                    this.closeDialog();
                    this.$router.push('/');
                }
            });

            // Swal.disableButtons();
            // document.getElementById("tos").document.addEventListener('scroll', this.onScroll);
        },
        closeDialog() {
            this.$emit('loaded');
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        }   
  }
}
</script>

<template>
  <Layout>
    <div v-on:loaded="setTosOk">
    </div>
  </Layout>
</template>


<style lang="scss">
    .swal2-height{
            height: 100%;
            width: 60%;

            .swal2-content{
                height: 100% !important;
                width: 100%;

                #swal2-content{
                    height: 100% !important;
                    width: 100%;

                    iframe{
                        height:100% !important;
                        width: 100%;
                    }
                }
            }
        }
</style>
